import AutomobileAsset from '../../asset/automobile-asset';
import { StringValue, WrappedHTMLElement } from '../../util/parse-data';

export function parseCondition(condition: StringValue | null) {
  if (!condition) return null;
  if (condition.value === 'New') return 'N';
  if (condition.value === 'Used') return 'U';
  return null;
}

export function parsePrice(priceAsString: StringValue | null) {
  if (!priceAsString) return 0;
  const priceAsInt = parseInt(priceAsString.value.replace(/[,\\$]/g, ''), 10);
  if (isNaN(priceAsInt)) return 0;
  return priceAsInt;
}

export function getPrice(container: HTMLElement) {
  const priceElement: HTMLElement | null = container.querySelector(
    '.dms-srp__price-wrapper, .dms-vdp__price-wrapper-internal'
  );
  if (!priceElement) return 0;
  const priceAsString = new WrappedHTMLElement(priceElement).getTextContent();
  return parsePrice(priceAsString);
}

export function getAutomobileAssetData(container: HTMLElement): AutomobileAsset {
  const wrappedContainer = new WrappedHTMLElement(container);
  const price = getPrice(container);
  const condition = parseCondition(wrappedContainer.getAttr('vehicle-condition'));
  const year = wrappedContainer.getAttr('vehicle-year')?.value ?? null;
  const make = wrappedContainer.getAttr('vehicle-make')?.value ?? null;
  const model = wrappedContainer.getAttr('vehicle-model')?.value ?? null;
  return new AutomobileAsset({ price, condition, year, make, model, originalPrice: price });
}

export function buildCtaRenderLocationElement(): HTMLElement {
  const ctaRenderLocation = document.createElement('div');
  ctaRenderLocation.classList.add('ol-target-element');
  return ctaRenderLocation;
}
